import { UNIT } from '../../../../../constant/unit'
import { getObjectUtil } from 'packages/src'
import { appMessages } from '../../../../../messages'
import { SET_DATA_KEY, SET_DATA_WEIGHT_KEY_BODY_WEIGHT } from '../../../model/constants'
import { getCountKeySetDataUtil, getCountValueLabelSetUtil } from '../../../model/utils'
import { EQUIPMENT, EQUIPMENT_MESSAGE } from '../../../../equipment'
import { getWeightUnitProfileSelect } from '../../../../profile/redux/selectors/get-weight-unit'
import { WEIGHT_UNIT_MESSAGE } from '../../../../weight/constants/unit'
import getCurrentSetDataWorkoutExerciseSelect from '../get-current-set-data'
import getCurrentSetIndexWorkoutExerciseSelect from '../get-current-set-index'
import { createSelector } from 'reselect'
import { formatMessageIntlUtil } from '../../../../intl'

export const getCurrentSetWorkoutExerciseSelect = createSelector(
  getCurrentSetDataWorkoutExerciseSelect,
  getCurrentSetIndexWorkoutExerciseSelect,
  (setData, setIndex) => {
    if (!setData) {
      return
    }
    return setData[setIndex]
  }
)

export const getNextSetWorkoutExerciseSelect = createSelector(
  getCurrentSetDataWorkoutExerciseSelect,
  getCurrentSetIndexWorkoutExerciseSelect,
  (setData, setIndex) => {
    if (!setData) {
      return
    }
    return setData[setIndex + 1]
  }
)

export function getSetCountKeyFromSetPropWorkoutExerciseSelector (isCurrentSet) {
  return (state, props) => {
    const set = isCurrentSet
      ? getCurrentSetWorkoutExerciseSelect(state)
      : props && props.set
    return getCountKeySetDataUtil(set)
  }
}

export function getSetCountValueFromSetPropWorkoutExerciseSelector (isCurrentSet) {
  return createSelector((state, props) => isCurrentSet
    ? getCurrentSetWorkoutExerciseSelect(state)
    : props && props.set,
  getSetCountKeyFromSetPropWorkoutExerciseSelector(),
  (set, countKey) => getObjectUtil(set, countKey)
  )
}

export function isRestWorkoutExerciseSetSelector (isCurrentSet) {
  return (state, props) => {
    const set = isCurrentSet
      ? getCurrentSetWorkoutExerciseSelect(state)
      : props && props.set
    return getObjectUtil(set, SET_DATA_KEY.REST) != null
  }
}

export const isRestWorkoutExerciseNextSetSelect = (state, props) => {
  const set = getNextSetWorkoutExerciseSelect(state, props)
  return getObjectUtil(set, SET_DATA_KEY.REST) != null
}

export const getNotesWorkoutExerciseSetSelect = (state) => {
  const set = getCurrentSetWorkoutExerciseSelect(state)
  return getObjectUtil(set, SET_DATA_KEY.NOTES) || ''
}

export const hasNotesWorkoutExerciseSetSelect = createSelector(getNotesWorkoutExerciseSetSelect,
  (notes) => !!notes
)

export function getWeightWorkoutExerciseSetSelector (isCurrentSet) {
  return (state, props) => {
    const set = isCurrentSet
      ? getCurrentSetWorkoutExerciseSelect(state)
      : props && props.set
    return getObjectUtil(set, SET_DATA_KEY.WEIGHT)
  }
}

export function getWeightUnitWorkoutExerciseSetSelector (isCurrentSet) {
  return createSelector((state, props) => isCurrentSet
    ? getCurrentSetWorkoutExerciseSelect(state)
    : props && props.set,
  getWeightUnitProfileSelect,
  (set, profileWeightUnit) => (
    getObjectUtil(set, SET_DATA_KEY.WEIGHT_UNIT) || profileWeightUnit || UNIT.IMPERIAL
  )
  )
}

export function getWeightKeyWorkoutExerciseSetSelector (isCurrentSet) {
  return createSelector(getWeightWorkoutExerciseSetSelector(isCurrentSet),
    (value) => (
      value != null
        ? SET_DATA_KEY.WEIGHT
        : SET_DATA_WEIGHT_KEY_BODY_WEIGHT
    )
  )
}

export function getWeightLabelWorkoutExerciseSetSelector ({ intl }) {
  return createSelector(
    getWeightWorkoutExerciseSetSelector(),
    getWeightKeyWorkoutExerciseSetSelector(),
    getWeightUnitWorkoutExerciseSetSelector(),
    (value, weightKey, weightUnit) => {
      if (weightKey === SET_DATA_KEY.WEIGHT) {
        return formatMessageIntlUtil(intl, appMessages.weightWithUnit, {
          weight: value,
          weightUnit: formatMessageIntlUtil(intl,
            WEIGHT_UNIT_MESSAGE[weightUnit]
          )
        })
      }
      return formatMessageIntlUtil(intl,
        EQUIPMENT_MESSAGE[EQUIPMENT.BODYWEIGHT]
      )
    }
  )
}

export function getCountValueLabelWorkoutExerciseSetSelect () {
  return createSelector(
    getSetCountKeyFromSetPropWorkoutExerciseSelector(),
    getSetCountValueFromSetPropWorkoutExerciseSelector(),
    (countKey, value) => getCountValueLabelSetUtil(countKey, value)
  )
}
